export const types = {
    ASSIGN: 'ASSIGN',
    DELCOLUMN: 'DELETE-COLUMN',
    DELROW: 'DELETE-ROW',
    INSERTROW: 'INSERT-ROW',
    INSERTCOLUMN: 'INSERT-COLUMN',
    JOIN: 'JOIN',
    MERGE: 'MERGE',
    DUPLICATE: 'REMOVE-DUPLICATE-ROWS',
    GETCOLUMN: 'GET-COLUMN',
    UPDATECELL: 'UPDATE-CELL',
    LENGTH: 'LENGTH',
    SORTROWS: 'SORT-ROWS',
    FILTERROWS: 'FILTER-ROWS',
    LIMITROWS: 'LIMIT-ROWS',
    MERGEDUPLITEROWS: 'MERGE-DUPLICATE-ROWS',
    FILLBLANKCELLS: 'FILL-BLANK-CELLS',
    SPLITCOLUMNS: 'SPLIT-COLUMNS',
    REPLACEWITHREGEX: 'REPLACE-WITH-REGEX',
    ADDROWNUMBERS: 'ADD-ROW-NUMBERS',
    COMBINETABLES: 'COMBINE-TABLES',
    MERGETABLES: 'MERGE-TABLES',
    ROTATETABLE: 'ROTATE-TABLE',
    TEXTFORMATTING: 'TEXT-FORMATTING',
    FINDANDREPLACE: 'FIND-&-REPLACE',
    MERGECOLUMNS: 'MERGE-COLUMNS',
    FINDMAXBYGROUP: 'FIND-MAX-BY-GROUP',
    FINDMINBYGROUP: 'FIND-MIN-BY-GROUP',
    MATHBYGROUP: 'MATH-BY-GROUP',
    FINDANDCLEAN: 'FIND-&-CLEAN',
    EXPORTTOCSV: 'EXPORT-TO-CSV'
};
